import { useState } from "react";
import { useFamily } from "@/lib/family";
import { Wordmark } from "@/components/Logo";

const BELT_CLASS = {
  white: "belt-white", blue: "belt-blue", purple: "belt-purple", brown: "belt-brown", black: "belt-black",
  "gray-white": "belt-gray-white", gray: "belt-gray", "gray-black": "belt-gray-black",
  "yellow-white": "belt-yellow-white", yellow: "belt-yellow", "yellow-black": "belt-yellow-black",
  "orange-white": "belt-orange-white", orange: "belt-orange", "orange-black": "belt-orange-black",
  "green-white": "belt-green-white", green: "belt-green", "green-black": "belt-green-black",
};

// Netflix-style profile picker: shown when a user has >1 linked
// student profile (parent with multiple kids) and hasn't picked one
// yet on the current session.
export default function StudentChooser() {
  const { members, switchTo } = useFamily();
  const [picking, setPicking] = useState(null);
  const [error, setError] = useState("");

  const pick = async (m) => {
    setPicking(m.student_id); setError("");
    try {
      await switchTo(m.student_id);
      // No navigate needed — StudentLayout re-renders and drops the chooser.
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not switch profile");
      setPicking(null);
    }
  };

  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh" }} data-testid="student-chooser">
      <div className="mx-auto" style={{ maxWidth: 460, padding: "24px 20px" }}>
        <div className="flex justify-center mb-8">
          <Wordmark size={18} />
        </div>
        <div className="text-center mb-8">
          <div className="label" style={{ color: "var(--green)" }}>Family</div>
          <h1 className="text-[26px] font-bold tracking-tight mt-1 uppercase">Who&apos;s training today?</h1>
          <div className="label-tiny mt-2" style={{ color: "var(--text-dim)" }}>Pick a profile to continue</div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {members.map((m) => {
            const isPicking = picking === m.student_id;
            return (
              <button
                key={m.student_id}
                onClick={() => pick(m)}
                disabled={!!picking}
                className="card p-4 flex flex-col items-center gap-3 transition-transform hover:scale-105 disabled:opacity-50"
                style={{ borderColor: isPicking ? "var(--green)" : "var(--border)" }}
                data-testid={`chooser-profile-${m.student_id}`}
              >
                <div className="w-20 h-20 rounded-full flex items-center justify-center overflow-hidden shrink-0"
                     style={{ background:"var(--bg-elev)", border:"2px solid var(--border)" }}>
                  {m.avatar
                    ? <img src={m.avatar} alt="" className="w-full h-full object-cover" />
                    : <span className="text-[20px] font-bold" style={{color:"var(--green)"}}>{m.initials}</span>}
                </div>
                <div className="text-center min-w-0 w-full">
                  <div className="font-semibold uppercase tracking-tight text-[13px] truncate">{m.name}</div>
                  <div className="belt-chip mt-2 justify-center">
                    <span className={`belt-bar ${BELT_CLASS[m.belt] || "belt-white"}`} />
                    <span className="label-tiny capitalize">{m.belt} · {m.stripes}</span>
                  </div>
                </div>
                {isPicking && <div className="label-tiny" style={{color:"var(--green)"}}>Opening…</div>}
              </button>
            );
          })}
        </div>
        {error && <div className="label-tiny mt-6 text-center" style={{color:"var(--danger)"}} data-testid="chooser-error">{error}</div>}
      </div>
    </div>
  );
}
